dcyAngular.internalDefine('classes/com/decisyon/core/environment/DcyEnv',["require","exports"],function(require,exports){"use strict";Object.defineProperty(exports,"__esModule",{value:!0});class DcyEnv{}DcyEnv.ENV_VARS=ENV_VARS,DcyEnv.LANGUAGES=LANGUAGES,DcyEnv.rootPage=rootPage,DcyEnv.pageUIDIdentifier=rootPage.pageUIDIdentifier,DcyEnv.sendJavascriptError=sendJavascriptError,exports.default=DcyEnv});
//# sourceMappingURL=DcyEnv.js.map

require(["classes/com/decisyon/core/environment/DcyEnv"]);

